/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsBillingInvoiceCtrl
 */
angular.module('mercury.modules.settings.billing')
.controller('SettingsBillingInvoiceCtrl', ["$scope", "invoice", "paymentTypes", function($scope, invoice, paymentTypes) {
  $scope.invoice = invoice;
  $scope.paymentTypes = paymentTypes;

  $scope.getPaymentTypeName = function(invoiceType) {
    var rtn = 'Demo';
    angular.forEach($scope.paymentTypes, function(paymentType) {
      if (paymentType.type == invoiceType) {
        rtn = paymentType.name;
      }
    });

    return rtn;
  };

  $scope.printInvoice = function() {
    var printContents = document.getElementById('invoicePrint').innerHTML;
    var popupWin = window.open('', '_blank');
    var windowContent = '<html><head><link href="/css/app.css" rel="stylesheet" type="text/css">' +
      '<link href="https://fonts.googleapis.com/css?family=Open+Sans:400,600,700" rel="stylesheet" type="text/css">' +
      '</head><body onload="window.print()">' + printContents + '</body></html>';
    popupWin.document.open();
    popupWin.document.write(windowContent);
    popupWin.document.close();
  };
}]);
